import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ba60386"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-lg font-bold text-secondary50" }
const _hoisted_2 = { class: "text-base text-secondary50 leading-relaxed" }
const _hoisted_3 = {
  key: 1,
  "data-testid": "handover-qualification-block",
  class: "flex flex-col gap-2 rounded-lg p-3 mt-4 bg-red-50 border border-negative/40 text-left"
}
const _hoisted_4 = { class: "text-sm font-bold text-textPrimary" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-[#52526f]" }, " Na troca, quem recebe o plantão precisa atender à Qualificação exigida (sem pré-alocação). ", -1))
const _hoisted_6 = {
  key: 2,
  "data-testid": "schedule-conflict-alert",
  class: "flex flex-col gap-2 rounded-lg p-3 mt-4 bg-[#FEF9E7] border border-warning text-left"
}
const _hoisted_7 = { class: "flex flex-wrap items-center gap-2" }
const _hoisted_8 = { class: "text-sm text-[#16161d] leading-[18px]" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Conflito de agenda:", -1))
const _hoisted_10 = { class: "flex flex-col gap-1" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-[#16161d] leading-[18px] font-medium" }, " Este conflito não impede a aprovação — você pode aprovar mesmo assim. ", -1))
const _hoisted_12 = {
  key: 3,
  "data-testid": "approval-reminder-callout",
  class: "flex items-start gap-2 rounded-lg p-3 mt-4 bg-[#edf5ff] border border-[#0f62fe]"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-[#16161d] leading-[18px] text-left" }, " Ao aprovar, você confirma a autorização do profissional para este plantão e garante a atualização no sistema ou planilha da contratante. ", -1))
const _hoisted_14 = { class: "flex items-center gap-6 mt-6" }

import { computed } from 'vue'
import { format, parseISO } from 'date-fns'
import { mdiInformationOutline } from '@mdi/js'
import ModalVue from '@/components/designSystem/modals/Modal.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import ConsecutiveHoursBlockAlert from '@/components/designSystem/Alerts/ConsecutiveHoursBlockAlert.vue'
import LabelBadge from '@/components/designSystem/Badges/LabelBadge.vue'
import { ScheduleConflictsSummary } from '@/Network/Types/Responses/HandoverInviteResponses'
import type { ConsecutiveHoursViolation } from '@/Network/Types/Responses/ConsecutiveHoursResponses'
import QualificationMissingList from '@/components/Qualification/QualificationMissingList.vue'
import type { EligibilityReason } from '@/types/qualification-eligibility.types'


export default /*#__PURE__*/_defineComponent({
  __name: 'HandoverConfirmationModal',
  props: {
    modelValue: { type: Boolean },
    title: {},
    message: {},
    variant: {},
    loading: { type: Boolean },
    scheduleConflicts: {},
    consecutiveHoursViolations: {},
    qualificationMissing: {},
    qualificationMessage: {}
  },
  emits: ["update:modelValue", "confirm"],
  setup(__props: any) {

const props = __props;





const hasScheduleConflicts = computed(
  () =>
    props.variant === 'approve' &&
    !!props.scheduleConflicts &&
    props.scheduleConflicts.conflicts.length > 0
)

// Bloqueio duro: diferente do conflito de agenda, esta regra não tem "mesmo assim".
const hasConsecutiveHoursViolations = computed(
  () => props.variant === 'approve' && (props.consecutiveHoursViolations?.length ?? 0) > 0
)

// Também bloqueio duro: na troca, pré-alocável não serve (D65).
const hasQualificationBlock = computed(
  () => props.variant === 'approve' && !!props.qualificationMessage
)

const confirmButtonText = computed(() =>
  hasScheduleConflicts.value && !hasConsecutiveHoursViolations.value && !hasQualificationBlock.value
    ? 'Aprovar mesmo assim'
    : 'Aprovar'
)

const formatConflictDate = (dateStr: string) => {
  try {
    return format(parseISO(dateStr), 'dd/MM/yyyy')
  } catch {
    return dateStr
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(ModalVue, {
    "modal-active": _ctx.modelValue,
    "max-width": "max-w-[600px]",
    onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('update:modelValue', false)))
  }, {
    header: _withCtx(() => [
      _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.title), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.message), 1),
      (_ctx.variant === 'approve')
        ? (_openBlock(), _createBlock(ConsecutiveHoursBlockAlert, {
            key: 0,
            violations: _ctx.consecutiveHoursViolations ?? [],
            "show-block-badge": "",
            class: "mt-4"
          }, null, 8, ["violations"]))
        : _createCommentVNode("", true),
      (hasQualificationBlock.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.qualificationMessage), 1),
            (_ctx.qualificationMissing?.length)
              ? (_openBlock(), _createBlock(QualificationMissingList, {
                  key: 0,
                  missing: _ctx.qualificationMissing
                }, null, 8, ["missing"]))
              : _createCommentVNode("", true),
            _hoisted_5
          ]))
        : _createCommentVNode("", true),
      (hasScheduleConflicts.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("p", _hoisted_8, [
                _hoisted_9,
                _createTextVNode(" Dr(a). " + _toDisplayString(_ctx.scheduleConflicts?.doctorName) + " já está alocado(a) em " + _toDisplayString(_ctx.scheduleConflicts?.conflicts.length) + " plantão(ões) que se sobrepõe(m) a este convite: ", 1)
              ]),
              _createVNode(LabelBadge, {
                label: "REQUER ATENÇÃO",
                color: "yellow",
                size: "small",
                icon: null
              })
            ]),
            _createElementVNode("ul", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scheduleConflicts?.conflicts, (conflict, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  class: "text-sm text-[#16161d] leading-[18px]"
                }, " • " + _toDisplayString(formatConflictDate(conflict.date)) + " · " + _toDisplayString(conflict.startHour) + "—" + _toDisplayString(conflict.endHour) + " · " + _toDisplayString(conflict.healthUnitName) + " — " + _toDisplayString(conflict.scheduleName), 1))
              }), 128))
            ]),
            _hoisted_11
          ]))
        : _createCommentVNode("", true),
      (_ctx.variant === 'approve')
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createVNode(_component_v_icon, {
              icon: _unref(mdiInformationOutline),
              size: "18",
              color: "#0f62fe",
              class: "shrink-0 mt-0.5"
            }, null, 8, ["icon"]),
            _hoisted_13
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_14, [
        (_ctx.variant === 'approve')
          ? (_openBlock(), _createBlock(OutlineButton, {
              key: 0,
              text: "Cancelar",
              width: "48%",
              height: "40px",
              disabled: _ctx.loading,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', false)))
            }, null, 8, ["disabled"]))
          : _createCommentVNode("", true),
        (_ctx.variant === 'approve')
          ? (_openBlock(), _createBlock(FilledButton, {
              key: 1,
              text: confirmButtonText.value,
              width: "48%",
              height: "40px",
              disabled: _ctx.loading || hasConsecutiveHoursViolations.value || hasQualificationBlock.value,
              class: "bg-primary30",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('confirm')))
            }, null, 8, ["text", "disabled"]))
          : _createCommentVNode("", true),
        (_ctx.variant === 'decline')
          ? (_openBlock(), _createBlock(FilledButton, {
              key: 2,
              text: "Cancelar",
              width: "48%",
              height: "40px",
              disabled: _ctx.loading,
              class: "bg-primary30 border-2 border-solid",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:modelValue', false)))
            }, null, 8, ["disabled"]))
          : _createCommentVNode("", true),
        (_ctx.variant === 'decline')
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 3,
              variant: "outlined",
              color: "error",
              class: "flex-1 normal-case border-2 font-bold",
              width: "48%",
              height: "40",
              disabled: _ctx.loading,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('confirm')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Confirmar ")
              ]),
              _: 1
            }, 8, ["disabled"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["modal-active"]))
}
}

})